import styles from "./LanguageSelector.module.css";

const LANG_LABELS: Record<string, string> = {
  fr: "🇫🇷 Français",
  en: "🇬🇧 English",
  nl: "🇳🇱 Nederlands",
};

interface LanguageSelectorProps {
  langs: readonly string[];
  value: string;
  onChange: (lang: string) => void;
}

export function LanguageSelector({
  langs,
  value,
  onChange,
}: LanguageSelectorProps) {
  return (
    <div className={styles.langButtons}>
      {langs.map((lang) => (
        <button
          key={lang}
          type="button"
          className={`${styles.langBtn} ${value === lang ? styles.langBtnActive : ""}`}
          onClick={() => onChange(lang)}
        >
          {LANG_LABELS[lang] ?? lang}
        </button>
      ))}
    </div>
  );
}
